<template>
  <div>
    <Loading v-if="isLoading"></Loading>
    <div
      v-else
      class="bg-gray-200 text-center flex-col p-4 rounded-lg py-8 flex items-center justify-center min-h-screen"
    >
      <h2 class="text-2xl mb-3 font-bold">Request Authorization</h2>
      <p>
        Once you send submit, a snapshot of your system and details will be sent
        to be registered
      </p>
      <button
        class="uppercase my-6 w-64 shadow m-2 bg-blue-600 text-white focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded"
        @click="submitAuthorizationRequest"
      >
        Submit Request
      </button>
      <div
        v-if="message"
        class="w-2/3 mx-auto py-2 text-white"
        :class="messageClass"
      >
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import WhitelistingMixin from "../modules/WhitelistingMixin";
import { GET_USER_DATA } from "../browser-db-config/localStorage";
import Loading from "./general-components/Loading.vue";
export default {
  mixins: [WhitelistingMixin],
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      message: "",
      messageClass: "",
    };
  },
  methods: {
    submitAuthorizationRequest() {
      this.isLoading = true;
      this.getDeviceDetails()
        .then((deviceDetails) => {
          const { _id, email, name } = GET_USER_DATA();
          const payload = {
            user: { _id, email, name, key: this.WLdeviceId },
            device: deviceDetails,
          };

          return fetch(process.env.VUE_APP_REQUEST_INSPECT_URL, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });
        })
        // .then(response => response.json())
        .then((result) => {
          if (result.ok) {
            this.message = "Authorization Request has been submitted";
            this.messageClass = "bg-green-500";
          } else {
            this.message = result.message || "An error occurred";
            this.messageClass = "bg-red-500";
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.message = error.message || "An error occurred";
          this.messageClass = "bg-red-500";
          this.isLoading = false;
        });
    },
  },
};
</script>